export default __webpack_public_path__ + "static/media/07.06fbda46.png";